import { isEmpty } from 'lodash';
import { call, select } from 'redux-saga/effects';

import * as apiCommon from '../services/apiCommon';
import { promptModal } from './sagas_utils/sagas_common_utils';
import { getParticularPreferenceSettings } from '../common/selectors/preference';
import { isEmployee as isEmployeeSelector } from '../components/admin/employee/EmployeeSelector';

export function* precheckEntity(feathersApp, action) {
  const isEmployee = yield select(isEmployeeSelector);
  const { value: emailUniqPref } =
    (yield select(getParticularPreferenceSettings, "entity_email_unique", [
      "value",
    ])) || {};
  const { value: contactUniqPref } =
    (yield select(
      getParticularPreferenceSettings,
      "entity_contact_number_unique",
      ["value"],
    )) || {};
  const isEmailUniqWarn = emailUniqPref === 'WARNING'
  const isContactUniqWarn = contactUniqPref === 'WARNING';

  if (isEmailUniqWarn || isContactUniqWarn) {
    const filters = {};
    const contactNumbers = action.data.contact_numbers.map((c) => c.value);

    filters.excluded_entities = action.data.id ? [action.data.id] : filters.excluded_entities;
    filters.email = isEmailUniqWarn && !isEmployee ? action.data.email : filters.email;
    filters.contact_numbers = isContactUniqWarn ? contactNumbers : filters.contact_numbers;

    if (isEmpty(filters)) {
      return false;
    }

    const dataParams = {
      filters,
      doc_type: "entity",
    };
    const match = yield call(apiCommon.getDocs, feathersApp, dataParams);
    const isNotUniqe = Boolean((match.data || []).length);

    if (isNotUniqe) {
      const msgHeader = "Duplicate found";
      const msgBody =
        "Duplicate record has been found." +
        " Are you sure you want to continue?";
      const ok = yield promptModal(msgHeader, msgBody, false);
      if (!ok) { return false; }
    }
  }

  return true;
}
